import { getAdjustedNow } from './contest-timing';

export const phoneNumberRegex = /^[0-9]{10}$/;

export const formatTime = (time?: number) => {
  if (!time) return '00';

  return time < 10 ? `0${time}` : time.toString();
};

export const getRemainingTime = (endTime: number, now = getAdjustedNow()) => {
  const remainingTime = endTime - now;

  if (remainingTime < 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

  const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
  const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

  return { days, hours, minutes, seconds };
};

export const formatWordPlural = (n: number, wordSingular: string, wordPlural: string) => {
  if (n === 1) {
    return wordSingular;
  }

  if (n < 20) {
    return `${n} ${wordPlural}`;
  }

  return `${n} de ${wordPlural}`;
};

export { initContestTiming, getAdjustedNow } from './contest-timing';

export {
  getCountdownData,
  isContestEnded,
  isContestStarted,
  isRegistrationEnded,
  isRegistrationStarted,
  isTutorialEnded,
  isTutorialInProgress,
  isTutorialRegistrationEnded,
  isTutorialRegistrationStarted,
} from './schedule';
